<div class="infobox" [ngClass]="cssClass()">
  @if (editRouterLink()) {
  <a
    class="float-right btn-tool"
    [routerLink]="editRouterLink()"
    [title]="'infobox.update.title' | translate : { '0': heading() | translate }"
  >
    <fa-icon [icon]="['fas', 'pencil-alt']" />
  </a>
  } @if (heading()) {
  <h2 class="h3">{{ heading() | translate }}</h2>
  }
  <ng-content />
</div>
